var make = require('./make_');
var arrForEach = require('../array/forEach');
var objForEach = require('../object/forOwn');

    /**
     */
    module.exports = make(arrForEach, objForEach);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/forEach.js
// module id = 684
// module chunks = 0 1 2